import {ComboProductQuantity} from './ComboProductQuantity'
import {SelectComboCategories} from './SelectComboCategories'

export const ProductComboProducts = () => {
  return (
    <div className="flex flex-col gap-6">
      <SelectComboCategories />
      <ComboProductQuantity />
    </div>
  )
}
